const attachment_utility = require('civicsUtils/attachment_utility');
define(function(require) {
	var IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/cdr/reviews/{0}',
		parse:function(response){
			var data = response.data ? response.data : response;
			// data.reviewAttachments = attachmentConverter.convertAttachments(data.reviewAttachments ? data.reviewAttachments : data.attachments)
			data.reviewAttachments = data.reviewAttachments || data.attachments;
			attachment_utility.parseVirusScanStatus(data.reviewAttachments);
			return data;
		}
	})
});
